import { h } from "preact";

const Footer = () => {
  return (
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          {" "}
          Designed and Developed with ❤️ and 🔥 by{" "}
          <a href="https://insanenaman.com" target="_blank">
            <strong>Naman Gupta</strong>
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
